module.exports = __webpack_public_path__ + "static/media/Calendar Date Mark Check.ab202a98.svg";